import { AlertsResponse } from './alerts.interfaces';
import { Utils } from '@app/_helpers';
import { Quote } from '@app/_shared';

export class AlertsModel implements AlertsResponse {
  alert_time = 0
  algo_category = ''
  algo_id = ''
  algo_name = ''
  algo_type = 0
  client_id = ''
  condition = ''
  condition_status = 0
  disclosed_quantity = 0
  market_id = 0
  mode_of_execution = 0
  order_mode = ''
  order_type = ''
  order_validity = ''
  price = 0
  product_type = ''
  quantity = 0
  scrip_name = ''
  security_id = 0
  trigger_price = 0
  id = 0
  scrip_precision = 0
  market_lot = 0
  tick_size = 0
  lots = 0
  ltp = 0
  Message = ''
  display_title = ''
  display_message = ''


  constructor(alert: AlertsResponse) {
    Object.keys(this).forEach(key => {
      this[key] = alert[key];
    });

    this.alert_time = alert.alert_time * 1e3;

  }

  setSymbolInfo(symbolInfo: number[]) {
    if (symbolInfo) {
      this.market_lot = symbolInfo[0];
      this.tick_size = symbolInfo[1];
      this.scrip_precision = symbolInfo[2];
    }
    else {
      this.market_lot = 1;
      this.tick_size = 1;
      this.scrip_precision = 2;
    }
    this.price = Utils.applyPrecision(this.price, this.scrip_precision);
    this.trigger_price = Utils.applyPrecision(this.trigger_price, this.scrip_precision);

    this.lots = this.quantity / this.market_lot;

  }


  setDisplayMessage() {
    this.display_title = `${this.order_mode} order placed by ${this.algo_name}`;
    this.display_message = `${this.algo_name} placed a ${this.order_mode} order on ${this.scrip_name} for ` +
      `${this.quantity} ${this.market_lot > 1 ? ' lots' : ' quantity'} at ${this.price}`;
  }

  listenLtp(quote: Quote) {
    this.ltp = quote.LTP;
    quote.ltpUpdate.subscribe(() => {
      this.ltp = quote.LTP;
    });
  }
}
